<template>
  <div class="messages-feed" ref="messagesFeed">
    <div v-for="message in messages" :key="message.id"
      :class="['message-wrapper', { 'own-message': message.from === user.id }]">

      <!-- User Avatar (for other user's messages) -->
      <div v-if="message.from !== user.id" class="message-avatar">
        <img :src="getOtherUserPhoto(message.from_contact.picture)" alt="" />
      </div>

      <div class="message-content">
        <!-- Offer Message Card -->
        <OfferCard v-if="message.type === 'REQUEST_OFFER' || message.type === 'RESPONSE_OFFER'" :message="message"
          :is-own="message.from === user.id" :user="user" :originalPrice="(() => {
            const ops = message.offer && message.offer.offer_products;
            const first = Array.isArray(ops) && ops.length ? ops[0] : null;
            return first && first.product && first.product.fixed_price ? parseInt(first.product.fixed_price) : (product && product.fixed_price ? parseInt(product.fixed_price) : (message.offer.old_price || 0));
          })()"
          :selected-contact="{ product: (message.offer && Array.isArray(message.offer.offer_products) && message.offer.offer_products[0] && message.offer.offer_products[0].product) ? message.offer.offer_products[0].product : product }"
          @respond="$emit('respond-offer', $event)" @click-image="$emit('move-to-product', $event)" />
        <!-- Regular Message -->
        <MessageBubble v-else-if="message.type !== 'ABOUT'" :message="message" :is-own="message.from === user.id" />
      </div>

    </div>
  </div>
</template>

<script>
import config from "@/config";
import userpng from '@/assets/img/user/user.webp';
import MessageBubble from "@/components/messenger/MessageBubble.vue";
import OfferCard from "@/components/messenger/OfferCard.vue";

export default {
  name: "MessagesFeed",
  components: {
    MessageBubble,
    OfferCard
  },
  data() {
    return {
      storageUrl: config.storageUrl
    };
  },
  props: {
    messages: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    otherUser: {
      type: Object,
      required: false,
      default: null
    }
  },
  methods: {
    scrollToBottom() {
      if (this.$refs.messagesFeed) {
        this.$refs.messagesFeed.scrollTop=this.$refs.messagesFeed.scrollHeight;
      }
    },
    getOtherUserPhoto(picture) {
      return this.storageUrl+picture||
        userpng;
    },
  }
};
</script>

<style scoped>
.messages-feed {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: var(--gray-50);
}

.message-wrapper {
  margin-bottom: 16px;
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.message-wrapper.own-message {
  justify-content: flex-end;
}

.message-content {
  max-width: 70%;
}

.message-avatar {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-bottom: 6px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--gray-200);
}

.message-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.own-message .message-content {
  order: -1;
}

@media (max-width: 767px) {
  .message-content {
    max-width: 90%;
  }
}
</style>